import { render, staticRenderFns } from "./MailNotifyDetailFilter.vue?vue&type=template&id=0a05e0c1&"
import script from "./MailNotifyDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports